import PhotoPay from '@/views/PhotoPay/index.vue'

const PhotoPayRouter = {
  path: '/photo-pay',
  name: 'PhotoPay',
  component: PhotoPay,
  props: (route) => ({
    secret: route.query.secret
  })
}

export default PhotoPayRouter
